import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import Button from '../ui/Button';
import AuthLayout from './AuthLayout';
import toast from 'react-hot-toast';

const { FiArrowLeft } = FiIcons;

const TwoFactorAuth = () => {
    const [code, setCode] = useState(['', '', '', '', '', '']);
    const [loading, setLoading] = useState(false);
    const inputs = useRef([]);
    const navigate = useNavigate();

    useEffect(() => {
        // Focus first input on mount
        if (inputs.current[0]) inputs.current[0].focus();
    }, []);

    const handleChange = (index, value) => {
        if (value.length > 1) value = value.slice(-1);

        const newCode = [...code];
        newCode[index] = value;
        setCode(newCode);

        // Move to next input
        if (value && index < 5) {
            inputs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !code[index] && index > 0) {
            inputs.current[index - 1].focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').slice(0, 6).split('');
        const newCode = [...code];
        pastedData.forEach((char, i) => {
            if (i < 6) newCode[i] = char;
        });
        setCode(newCode);
        if (pastedData.length >= 6) {
            inputs.current[5].focus();
        } else {
            inputs.current[pastedData.length].focus();
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const fullCode = code.join('');
        if (fullCode.length < 6) {
            toast.error('Please enter the full code');
            return;
        }

        setLoading(true);
        // Simulate verification
        setTimeout(() => {
            setLoading(false);
            toast.success('Identity verified!');
            navigate('/');
        }, 1500);
    };

    return (
        <AuthLayout
            title="Two-factor authentication"
            subtitle="Enter the 6-digit code sent to your authenticator app."
        >
            <form onSubmit={handleSubmit} className="space-y-8">
                <div className="flex justify-between gap-2">
                    {code.map((digit, idx) => (
                        <input
                            key={idx}
                            ref={el => inputs.current[idx] = el}
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            maxLength={1}
                            value={digit}
                            onChange={e => handleChange(idx, e.target.value)}
                            onKeyDown={e => handleKeyDown(idx, e)}
                            onPaste={handlePaste}
                            className="w-12 h-14 text-center text-2xl font-bold rounded-xl border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 outline-none transition-all dark:text-white"
                        />
                    ))}
                </div>

                <div className="space-y-4">
                    <Button type="submit" className="w-full" isLoading={loading}>
                        Verify & Continue
                    </Button>
                    <div className="text-center">
                        <button type="button" className="text-sm font-semibold text-indigo-600 hover:text-indigo-500">
                            Resend code
                        </button>
                    </div>
                </div>

                <div className="text-center">
                    <Link to="/login" className="inline-flex items-center gap-2 text-sm font-semibold text-gray-600 dark:text-gray-400 hover:text-indigo-600 transition-colors">
                        <FiArrowLeft /> Back to login
                    </Link>
                </div>
            </form>
        </AuthLayout>
    );
};

export default TwoFactorAuth;